import { Badge } from '@mantine/core';
import { IconCircleCheck, IconClock, IconArchive } from '@tabler/icons-react';

import { RULE_PACK_STATUS_COLORS, RULE_PACK_STATUS_LABELS, type RulePackStatus } from '../types';

const STATUS_ICONS: Record<RulePackStatus, React.ReactNode> = {
  draft: <IconClock size={12} />,
  active: <IconCircleCheck size={12} />,
  retired: <IconArchive size={12} />,
};

interface Props {
  status: RulePackStatus;
  size?: 'xs' | 'sm' | 'md';
}

export function RulePackStatusBadge({ status, size = 'sm' }: Props): JSX.Element {
  return (
    <Badge
      color={RULE_PACK_STATUS_COLORS[status]}
      variant="light"
      size={size}
      leftSection={STATUS_ICONS[status]}
    >
      {RULE_PACK_STATUS_LABELS[status]}
    </Badge>
  );
}
